<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="login-title">Report Push </h2>
      <el-form @keyup.enter="handleLogin">
        <el-form-item>
          <el-input v-model="username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="password" type="password" placeholder="请输入密码" show-password />
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button 
            type="primary" 
            @click="handleLogin" 
            style="width: 100%"
            :loading="loading"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import http from '@/utils/http'
import { ElMessage } from 'element-plus'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const username = ref('')
    const password = ref('')
    const loading = ref(false)

    const handleLogin = async () => {
      if (loading.value) return
      loading.value = true
      try {
        const response = await http.post('/auth/api/v1/auth/login', {
          username: username.value,
          password: password.value
        });

        if (response.code === 200) {
          localStorage.setItem('auth-token', response.data.token);
          await checkLoginStatus();
          ElMessage.success('登录成功');
          router.push('/')
        }
      } catch (error) {
        console.error(error);
          ElMessage.error('登录失败');
      } finally {
        loading.value = false
      }
    };

    async function checkLoginStatus() {
      const token = localStorage.getItem('auth-token')
      if (token) {
        try {
          const response = await http.get('/auth/api/v1/user/me', {}, {
            Authorization: `Bearer ${token}`
          })
          if (response.code === 200) {
            localStorage.setItem('auth-user', JSON.stringify(response.data))
          } else {
            ElMessage.error('token验证失败，请重新登录', response);
          }
        } catch (error) {
          console.error(error)
        }
      }
    }

    return {
      username,
      password,
      loading,
      handleLogin
    }
  }
}
</script>

<style>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-box {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.login-title {
  margin-bottom: 30px;
  text-align: center;
  color: #409EFF;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 2px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
</style>
